module.exports = __webpack_public_path__ + "static/media/35.0762ff8c.jpg";